export const IconExclamation = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconExclamation_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconExclamation_svg__a)">
        <path d="M12 21q-.825 0-1.412-.587A1.93 1.93 0 0 1 10 19q0-.824.588-1.413A1.93 1.93 0 0 1 12 17q.825 0 1.412.587Q14 18.176 14 19q0 .824-.588 1.413A1.93 1.93 0 0 1 12 21m0-6q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 13V5q0-.824.588-1.412A1.93 1.93 0 0 1 12 3q.825 0 1.412.587Q14 4.176 14 5v8q0 .825-.588 1.412A1.93 1.93 0 0 1 12 15" />
      </g>
    </svg>
  );
};
